<template>
    <div :class="$vuetify.theme.dark ? 'logs' : 'log logs'">
        <img src="@/assets/img/Slice201.png" alt="" class="trust-bg" :style="{maxWidth: contentWidth == 'boxed' ? '1400px' : '100%'}">
        <div class="content">
            <p :class="$vuetify.theme.dark ? 'content_title content_title1' : 'content_title'">{{ $t("zeroTrust.downFTSafe") }}</p>
            <p :class="$vuetify.theme.dark ? 'content_des1' : 'content_des'">{{ $t("zeroTrust.nowDownLoad") }}</p>
            <div class="two-box">
                <div class="down_liucheng" v-for="(item,index) in processData" :key="index">
                    <img :src="item.img"/>
                    <p :class="$vuetify.theme.dark ? 'process-title1' : 'process-title'">{{ item.title }}</p>
                    <span :class="$vuetify.theme.dark ? 'process-text1' : 'process-text'">{{ item.content }}</span>
                </div>
            </div>
            <div class="three-box">
                <div class="down">
                    <div :class="$vuetify.theme.dark ? 'down_box' : 'down_box1'" @click="downFun">
                        <div class="show_box">
                            <img src="@/assets/img/trust-down2.png" class="down-img"/>
                            <p :class="$vuetify.theme.dark ? 'down-text1' : 'down-text'">{{ $t("zeroTrust.windows") }}</p>
                        </div>
                        <div class="active_box">
                            <img src="@/assets/img/Slice195.png" class="down_box2_img"/>
                            <p class="down_box2_text">{{ $t("zeroTrust.clickDown") }}</p>
                            <!-- <p class="down_box2_text2">{{ $t("zeroTrust.editionNum") }}</p> -->
                        </div>
                    </div>
                </div>
                <div class="down">
                    <div :class="$vuetify.theme.dark ? 'down_box' : 'down_box1'">
                        <div class="show_box">
                            <img src="@/assets/img/trust-down1.png" class="down-img"/>
                            <p :class="$vuetify.theme.dark ? 'down-text1' : 'down-text'">{{ $t("zeroTrust.MacDown") }}</p>
                        </div>
                        <div class="active_box">
                            <div style="display: flex;justify-content: center;align-items: center;margin-top: 105px;">
                                <img src="@/assets/img/Slice194.png" class="down_box2_img1"/>
                                <span style="position: absolute;color: #7085FF;">{{ $t("zeroTrust.comming") }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="down">
                    <div :class="$vuetify.theme.dark ? 'down_box' : 'down_box1'">
                        <div class="show_box">
                            <img src="@/assets/img/trust-down3.png" class="down-img"/>
                            <p :class="$vuetify.theme.dark ? 'down-text1' : 'down-text'">{{ $t("zeroTrust.androidDown") }}</p>
                            <img src="@/assets/img/Slice192.png" class="down-img-right" />
                        </div>
                        <div class="active_box">
                            <div class="down_box2_code">
                                <div class="text-pic qr-code" ref="androidqrCode"></div>
                            </div>
                            <p class="down_box2_text">{{ $t("zeroTrust.codeDown") }}</p>
                            <!-- <p class="down_box2_text2">{{ $t("zeroTrust.editionNum") }}</p> -->
                        </div>
                    </div>
                </div>
                <div class="down">
                    <div :class="$vuetify.theme.dark ? 'down_box' : 'down_box1'">
                        <div class="show_box">
                            <img src="@/assets/img/trust-down4.png" class="down-img"/>
                            <p :class="$vuetify.theme.dark ? 'down-text1' : 'down-text'">{{ $t("zeroTrust.iosDownload") }}</p>
                            <img src="@/assets/img/Slice192.png" class="down-img-right" />
                        </div>
                        <div class="active_box">
                            <div class="down_box2_code">
                                <div class="text-pic qr-code" ref="iosqrCode"></div>
                            </div>
                            <p class="down_box2_text">{{ $t("zeroTrust.codeDown2") }}</p>
                            <!-- <p class="down_box2_text2">{{ $t("zeroTrust.editionNum") }}</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
import QRCode from 'qrcodejs2'
    export default {
      data() {
        return {
            processData:[
                {img: require('@/assets/img/trust-process1.png'),title:this.$t("zeroTrust.clientDown"),content:this.$t("zeroTrust.baseOnOwnSystem")},
                {img: require('@/assets/img/trust-process2.png'),title:this.$t("zeroTrust.accountLogin"),content:this.$t("zeroTrust.IAMquickly")},
                {img: require('@/assets/img/trust-process3.png'),title:this.$t("zeroTrust.zeroTrust"),content:this.$t("zeroTrust.neiwaiNet")},
                {img: require('@/assets/img/trust-process4.png'),title:this.$t("zeroTrust.unifiedPortal"),content:this.$t("zeroTrust.unifiedEnter")},
                {img: require('@/assets/img/trust-process5.png'),title:this.$t("zeroTrust.dataSecurity"),content:this.$t("zeroTrust.yeWuYinShen")},
            ],
            contentWidth:this.$store.state.appConfig.app.contentWidth,
        }
      },
      created() {
        this.$nextTick(()=>{
            this.setCode()
        })
      },
      watch: {
        
      },
      mounted(){
        this.$watch('$store.state.appConfig.app.contentWidth', val => {
            this.contentWidth = this.$store.state.appConfig.app.contentWidth
        })
      },
      methods: {
        downFun() {
            // window.open("https://iotfirmware.cloudentify.com/ZTS/FTSafeLoginSetup_V1.1.0.0.exe")
            let urls = process.env.VUE_APP_ZERO_TRUST_URL
            window.open(urls)
        },
        setCode() {
            // let androidUrls = "http://console.yufasdp.cloudentify.com/api/pc/safe/downloadSafeLogin"
            // let iosUrls = "https://apps.apple.com/us/app/id6444753200"
            let androidUrls = process.env.VUE_APP_ZERO_TRUST_ANDROID_URL
            let iosUrls = process.env.VUE_APP_ZERO_TRUST_IOS_URL
            // android
            let androidqrCode = new QRCode(this.$refs.androidqrCode, {
                text: androidUrls,
                colorDark: '#000000',
                colorLight: '#ffffff',
                width: 80,
                height: 80,
                typeNumber: 100,
                correctLevel: QRCode.CorrectLevel.L
            })
            androidqrCode._el.title = ""

            // ios
            let iosqrCode = new QRCode(this.$refs.iosqrCode, {
                text: iosUrls,
                colorDark: '#000000',
                colorLight: '#ffffff',
                width: 80,
                height: 80,
                typeNumber: 100,
                correctLevel: QRCode.CorrectLevel.L
            })
            iosqrCode._el.title = ""
        }
      },
    }
  </script>
  
  <style lang='scss' scoped>
.log{
    background: #fff;
    border-radius: 8px;
}
.logs{
    border-radius: 8px;
}
.trust-bg{
    position: absolute;
    width: 1800px;
}
.content{
    padding-top: 80px;
    padding-left: 60px;
    position: relative;
    width: 100%;
    padding-bottom: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    // top: -300px;
    .content_title{
        font-size: 36px;
        text-align: left;
        width: 100%;
    }
    .content_title1{
        color: #D2CFE5;
    }
    .content_des{
        color: #667280;
        font-size: 18px;
        text-align: left;
        width: 100%;
    }
    .content_des1{
        color: #A4A1B2;
        font-size: 18px;
    }
    .two-box{
        margin-top: 90px;
        display: flex;
        flex-wrap: wrap;
        .down_liucheng{
            margin-right: 41px;
            width: 257px;
            text-align: center;
            // background: #FFFFFF;
            // box-shadow: 0px 0px 3px 2px rgb(17 18 19 / 8%);
            border-radius: 12px;
            position: relative;
            .process-title{
                margin-top: 30px;
                font-size: 16px;
                color: #333;
                font-weight: bold;
            }
            .process-title1{
                margin-top: 30px;
                font-size: 16px;
                color: #ccc;
                font-weight: bold;
            }
            .process-text{
                font-size: 14px;
                color: #667280;
                width: 184px;
                text-align: left;
                display: inline-block;
            }
            .process-text1{
                font-size: 14px;
                color: #e7e3fcad;
                width: 184px;
                text-align: left;
                display: inline-block;
            }
        }
    }
    .three-box{
        margin-top: 60px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .down{
            margin-right: 41px;
            width: 257px;
            text-align: center;
            // background: #FFFFFF;
            justify-content: center;
            // box-shadow: 0px 0px 3px 2px rgb(17 18 19 / 8%);
            border-radius: 12px;
            cursor: pointer;
            position: relative;
            .down_box{
                width: 220px;
                height: 280px;
                background: url("../../assets/img/trust-down-bg.png");
            }
            .down_box1{
                width: 220px;
                height: 280px;
                background: url("../../assets/img/trust-down-bg1.png");
                margin-bottom: 20px;
            }
            .down_box:hover{
                    // display: none;
                background: url("../../assets/img/Slice197.png");
                .active_box{
                    display: flex;
                }
                .show_box{
                    display: none;
                }
            }
            .down_box1:hover{
                    // display: none;
                background: url("../../assets/img/Slice197-1.png");
                .active_box{
                    display: flex;
                }
                .show_box{
                    display: none;
                }
            }
            .show_box{
                    text-align: center;
                    position: relative;
            }
            .active_box{
                display: none;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .down_box2_img{
                    margin-top: 60px;
                    width: 80px;
                    height: 80px;
                }
                .down_box2_img1{
                    // margin-top: 105px;
                    width: 80px;
                    height: 80px;
                }
                .down_box2_text{
                    font-size: 16px;
                    color: #fff;
                    width: 100%;
                    margin-top: 50px;
                    line-height: 20px;
                }
                .down_box2_text2{
                    font-size: 12px;
                    color: #fff;
                    width: 100%;
                }
                .down_box2_code{
                    background: #fff;
                    width: 92px;
                    height: 92px;
                    border-radius: 10px;
                    margin-top: 60px;
                }
                .text-pic {
                    margin-bottom: 10px;
                }
                .qr-code {
                    padding: 6px;
                    border-radius: 6px;
                }
            }
            .down-img{
                margin-top: 60px;
            }
            .down-text{
                font-size: 18px;
                color: #333;
                width: 100%;
                margin-top: 70px;
            }
            .down-text1{
                font-size: 18px;
                color: #D2CFE5;
                width: 100%;
                margin-top: 70px;
            }
            .down-img-bg{
                position: absolute;
                bottom: 0;
                left: 0;
            }
            .down-img-right{
                position: absolute;
                right: 0px;
                top: 0px;
            }
        }
    }
}
  </style>